import { Alert, Stack, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { formatMoney } from "@bw/shared/utils";
import { PlatformPage } from "@/components/PlatformPage";
import { useFeePolicyVersion } from "../hooks/useFeePolicies";
import { fractionToPercent } from "../contractTermsDraft";

export function FeePolicyVersionPage() {
  const { versionId } = useParams<{ versionId: string }>();
  const query = useFeePolicyVersion(versionId);
  return (
    <PlatformPage title="Stored fee terms" isLoading={query.isLoading}>
      {query.isError ? (
        <Alert severity="warning">Exact stored version unavailable.</Alert>
      ) : query.data ? (
        <Stack spacing={2}>
          <Typography variant="body2">
            Effective {new Date(query.data.effective_from).toLocaleString()}
            {query.data.effective_until
              ? ` until ${new Date(query.data.effective_until).toLocaleString()}`
              : ""}
            .
          </Typography>
          {query.data.rules.map((rule, index) => (
            <Stack key={index} spacing={0.5}>
              <Typography variant="subtitle2">
                {rule.component === "bw_commission"
                  ? "BW commission"
                  : "Acquisition fee"}
              </Typography>
              <Typography variant="body2">
                {fractionToPercent(String(rule.percentage))}%
              </Typography>
              <Typography variant="body2">
                Flat fee:{" "}
                {rule.flat_fee
                  ? formatMoney(
                      rule.flat_fee.amount_minor / 100,
                      rule.flat_fee.currency,
                    )
                  : "Not set"}
              </Typography>
              <Typography variant="body2">
                Cap:{" "}
                {rule.cap
                  ? formatMoney(rule.cap.amount_minor / 100, rule.cap.currency)
                  : "Not set"}
              </Typography>
            </Stack>
          ))}
          <Alert severity="info">
            This read is not a new publication approval.
          </Alert>
        </Stack>
      ) : null}
    </PlatformPage>
  );
}
